import React from 'react';
import Header from './Header';
import Footer from './Footer';

const sections = [
  {
    number: '01',
    title: 'Quem somos',
    content: (
      <p>
        Esta Política de Privacidade se aplica aos aplicativos desenvolvidos e disponibilizados pela <strong>DevCoski</strong>, com sede em Santos, SP, Brasil. Ela explica como coletamos, usamos, armazenamos e protegemos informações quando você utiliza nossos aplicativos em dispositivos Android e Apple.
      </p>
    ),
  },
  {
    number: '02',
    title: 'Informações que podemos coletar',
    content: (
      <>
        <p>Dependendo do aplicativo e dos recursos utilizados, podemos coletar:</p>
        <ul>
          <li><strong>Informações fornecidas por você:</strong> nome, e-mail e dados enviados ao criar uma conta ou entrar em contato conosco.</li>
          <li><strong>Dados de uso:</strong> telas acessadas, recursos utilizados, preferências e interações com o aplicativo.</li>
          <li><strong>Dados técnicos:</strong> modelo do dispositivo, sistema operacional, idioma, identificadores técnicos e informações de diagnóstico.</li>
          <li><strong>Informações de compra:</strong> dados relacionados a assinaturas ou compras realizadas pelas lojas Google Play e App Store. Não armazenamos os dados completos do seu cartão.</li>
        </ul>
      </>
    ),
  },
  {
    number: '03',
    title: 'Como usamos as informações',
    content: (
      <>
        <p>Usamos as informações coletadas para:</p>
        <ul>
          <li>fornecer, manter e melhorar nossos aplicativos;</li>
          <li>personalizar sua experiência e lembrar suas preferências;</li>
          <li>processar assinaturas e disponibilizar recursos adquiridos;</li>
          <li>identificar falhas, prevenir abusos e manter a segurança;</li>
          <li>responder a solicitações de suporte; e</li>
          <li>cumprir obrigações legais e regulatórias aplicáveis.</li>
        </ul>
      </>
    ),
  },
  {
    number: '04',
    title: 'Compartilhamento e terceiros',
    content: (
      <p>
        Não vendemos suas informações pessoais. Podemos compartilhá-las somente quando necessário com prestadores de serviço que nos ajudam a operar os aplicativos, como provedores de hospedagem, análise e suporte. Esses parceiros recebem apenas os dados necessários para executar seus serviços e devem tratá-los de acordo com obrigações de confidencialidade e segurança. Também podemos compartilhar informações quando exigido por lei ou para proteger direitos, segurança e integridade dos usuários e da DevCoski.
      </p>
    ),
  },
  {
    number: '05',
    title: 'Armazenamento e segurança',
    content: (
      <p>
        Adotamos medidas técnicas e organizacionais razoáveis para proteger suas informações contra acesso não autorizado, perda, uso indevido ou alteração. Mantemos os dados somente pelo período necessário para as finalidades descritas nesta política ou para cumprir obrigações legais. Nenhum sistema é completamente seguro, por isso recomendamos manter seu dispositivo e suas credenciais protegidos.
      </p>
    ),
  },
  {
    number: '06',
    title: 'Seus direitos e escolhas',
    content: (
      <p>
        Você pode solicitar acesso, correção ou exclusão de seus dados pessoais, além de esclarecimentos sobre o tratamento realizado. Também pode desinstalar o aplicativo a qualquer momento e gerenciar permissões nas configurações do seu dispositivo. Para exercer seus direitos, entre em contato pelo e-mail abaixo. Poderemos solicitar informações para confirmar sua identidade antes de atender ao pedido.
      </p>
    ),
  },
  {
    number: '07',
    title: 'Privacidade de crianças',
    content: (
      <p>
        Nossos aplicativos não são direcionados intencionalmente a crianças que não tenham idade mínima permitida pela legislação aplicável. Se você acredita que uma criança nos forneceu dados pessoais, entre em contato para que possamos avaliar e excluir essas informações quando apropriado.
      </p>
    ),
  },
  {
    number: '08',
    title: 'Atualizações desta política',
    content: (
      <p>
        Podemos atualizar esta Política de Privacidade para refletir mudanças em nossos aplicativos, serviços ou na legislação. A versão mais recente estará sempre disponível nesta página. Quando houver alterações relevantes, destacaremos a atualização no aplicativo ou por outro meio apropriado.
      </p>
    ),
  },
];

function PrivacyPolicy() {
  return (
    <div className="privacy-page">
      <Header />
      <main>
        <section className="privacy-hero">
          <div className="privacy-hero-inner">
            <span className="section-label">Transparência em primeiro lugar</span>
            <h1>Política de <span>Privacidade</span></h1>
            <p>Como cuidamos das informações de quem usa os aplicativos DevCoski em Android e Apple.</p>
            <div className="privacy-meta">Última atualização: 25 de agosto de 2026</div>
          </div>
        </section>

        <section className="privacy-content">
          <aside className="privacy-aside" aria-label="Navegação da política">
            <span className="privacy-aside-label">Nesta página</span>
            <nav>
              {sections.map((section) => (
                <a href={`#secao-${section.number}`} key={section.number}>
                  <span>{section.number}</span>{section.title}
                </a>
              ))}
            </nav>
          </aside>
          <div className="privacy-sections">
            {sections.map((section) => (
              <article className="privacy-section" id={`secao-${section.number}`} key={section.number}>
                <span className="privacy-number">{section.number}</span>
                <div>
                  <h2>{section.title}</h2>
                  {section.content}
                </div>
              </article>
            ))}
            <article className="privacy-contact">
              <span className="section-label">Fale com a gente</span>
              <h2>Ficou com alguma dúvida?</h2>
              <p>Estamos disponíveis para esclarecer como seus dados são tratados.</p>
              <a href="mailto:contato@devcoski.tech" className="btn-primary-custom">contato@devcoski.tech</a>
            </article>
          </div>
        </section>
      </main>
      <Footer />
    </div>
  );
}

export default PrivacyPolicy;
